import { uri } from '../../api-endpoint';
import {
  IModelAPIValidationError,
  IModelFromAPISuccessResponse
} from '../../type-conversion/model/from-api-repsonse';
import { ModelAPIRequestBody } from '../../type-conversion/model/to-api-request-body';
import { updateTemplateFn } from '../common';

export const updateModel = (token: string) => (modelId: number) =>
  updateTemplateFn(
    token,
    uri.modelById(modelId),
    ModelAPIRequestBody,
    IModelFromAPISuccessResponse,
    IModelAPIValidationError
  );
